
import Vue from 'vue'
import { Prop, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import Service from '../../models/service'
import ServiceService from '@/services/ServiceService'
import Role from '../../models/role'
import {Group} from '../../models/group'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '../Atomic/CardTitle.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'
import ToolTipButton from '@/components/Atomic/ToolTipButton.vue'

@Component({
  components: {
    ToolTipButton,
    ProgressLinear,
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
  },
})
export default class CreateService extends Vue {
  public dialog: boolean = false
  public isPending: boolean = false
  public service: Service

  @Prop() public readonly roles!: Role[]
  @Prop(Function) public readonly create!: (service: Service) => void
  @Prop(Boolean) public readonly reset!: boolean
  private selectAssign: string[] = []
  private selectTarget: string[] = []
  private returnObject: boolean = false
  private groupNames: Group[] = []
  private errorHandlerService: ErrorHandlerService

  constructor() {
    super()
    this.service = new Service('', false, '', 0, [], [])
    this.fetchGroupNames()
    this.errorHandlerService = new ErrorHandlerService()
  }

  private async fetchGroupNames() {
    try {
      this.groupNames = await ServiceService.availableGroupNames()
    } catch (error: any) {
      if (error.response !== undefined) {
        this.errorHandlerService.handle(this, error.response.data.code, true)
      }
    }
  }

  @Watch('service', { deep: true })
  private onServiceChanged() {
    const groupObject: Group | undefined = this.groupNames.find(
      (element) => element.groupe_ad_id === this.service.groupe_ad_id,
    )
    if (groupObject) {
      this.service.ad_group_name = groupObject.nom
      this.service.school_specific = groupObject.etablissement_specifique
    } else {
      this.service.school_specific = false
    }
  }

  private async save() {
    this.isPending = true
    this.service.can_assign = this.selectAssign
    this.service.targets = this.selectTarget
    const validated = await this.$validator.validateAll()
    if (validated) {
      await this.create(this.service)
      this.dialog = false
      this.initialize()
    }

    this.isPending = false
  }
  private initialize() {
    this.fetchGroupNames()
    this.service = new Service('', false, '', 0, [], [])
    this.selectAssign = []
    this.selectTarget = []

    this.$validator.reset()
  }
  private cancel() {
    this.isPending = false
    this.dialog = false
    this.initialize()
  }
}
